"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
var _generateLinks = require("../../utils/generateLinks");
var _downCaretDarkBlue = _interopRequireDefault(require("../../images/down-caret-dark-blue.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../images/right-caret-light-gray.svg"));
var _useOpenCategory = _interopRequireDefault(require("./useOpenCategory"));
var _useFocus = require("../../utils/hooks/useFocus");
var _MobileMegaMenuSubCategory = _interopRequireDefault(require("./MobileMegaMenuSubCategory"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const MobileMegaMenuCategory = _ref => {
  let {
    name,
    links,
    toggleCategory,
    isOpen,
    parentOpen,
    closeDropDown,
    Link,
    megaMenuContentText,
    categoryId
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const {
    openCategory: openSubCategory,
    toggleCategory: toggleSubCategory
  } = (0, _useOpenCategory.default)(isOpen);

  //Sets references to collapsed and uncollapsed menus
  const [collapsedMenu, setCollapsedMenu] = (0, _useFocus.useFocus)();
  const [uncollapsedMenu, setUncollapsedMenu] = (0, _useFocus.useFocus)();
  const generateSubMenu = () => {
    if (links && links?.length) return links.map((link, index) => {
      if (link?.type === "megaNavColumn") {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenuSubCategory.default, {
          key: `${megaMenuContentText}-${link?.contentfulId}`,
          links: link?.links,
          name: link?.title || link?.text,
          isOpen: openSubCategory === link?.contentfulId,
          toggleCategory: toggleSubCategory,
          closeDropDown: closeDropDown,
          Link: Link,
          megaMenuContentText: megaMenuContentText,
          parentOpen: isOpen && openSubCategory === null,
          categoryId: link?.contentfulId
        });
      }
      if (link?.links) {
        return /*#__PURE__*/_react.default.createElement(_MobileMegaMenuSubCategory.default, {
          key: `${megaMenuContentText}-${link?.contentfulId}`,
          links: link?.links,
          name: link?.title || link?.text,
          isOpen: openSubCategory === link?.contentfulId,
          toggleCategory: toggleSubCategory,
          closeDropDown: closeDropDown,
          Link: Link,
          megaMenuContentText: megaMenuContentText,
          parentOpen: isOpen && openSubCategory === null,
          categoryId: link?.contentfulId
        });
      } else if (link && link !== null) {
        return /*#__PURE__*/_react.default.createElement("li", {
          className: "ter-mobile-mega-menu-category__name",
          key: `${link?.contentfulId}-${categoryId}-${index}`,
          onClick: closeDropDown
        }, (0, _generateLinks.generateSingleLink)(link, "ter-mobile-mega-menu-category__name", closeDropDown, openSubCategory === null, mouse, Link, 3));
      }
    });
  };
  const toggleCategoryWithEnter = (event, categoryId, direction) => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        toggleCategory(categoryId);
        //Accessibility - set the focus to the incoming menu
        if (direction === "open") {
          setCollapsedMenu();
        } else {
          setUncollapsedMenu();
        }
      }
    }
  };
  const handleClick = categoryId => {
    toggleCategory(categoryId);
  };

  //determines reveal direction based on subcategory states
  const getParentStyle = () => {
    let parentStyle = `ter-mobile-mega-menu--reveal--from-right `;
    if (isOpen && !openSubCategory) {
      parentStyle += "ter-mobile-mega-menu--reveal--from-right--visible";
    } else if (openSubCategory) {
      parentStyle += "ter-mobile-mega-menu--reveal--from-right--visible ter-mobile-mega-menu--reveal--from-right--reverse";
    }
    return parentStyle;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: getParentStyle()
  }, /*#__PURE__*/_react.default.createElement("p", {
    tabIndex: mouse ? "" : "0",
    onClick: () => toggleCategory(categoryId),
    onKeyDown: e => toggleCategoryWithEnter(e, categoryId, "open"),
    className: `ter-mobile-mega-menu__name ${isOpen && !openSubCategory ? "ter-mobile-mega-menu__name--open" : ""} ${mouse ? "" : "tabFocus"}`,
    "aria-haspopup": "menu",
    "aria-expanded": isOpen && !openSubCategory,
    ref: uncollapsedMenu,
    "data-depth": 2
  }, name, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu__caret ${isOpen && !openSubCategory ? "ter-mobile-mega-menu__caret--up" : "ter-mobile-mega-menu__caret--down"}`,
    src: _rightCaretLightGray.default,
    alt: "caret icon"
  })), /*#__PURE__*/_react.default.createElement("ul", {
    className: `ter-mobile-mega-menu-category__submenu ${isOpen && !openSubCategory ? "ter-mobile-mega-menu-category__submenu--is-open" : ""}`
  }, generateSubMenu())), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-mobile-mega-menu-category ${parentOpen ? "" : "ter-mobile-mega-menu-category--hidden"}`
  }, /*#__PURE__*/_react.default.createElement("p", {
    tabIndex: mouse ? "" : "0",
    onClick: () => handleClick(categoryId),
    onKeyDown: e => toggleCategoryWithEnter(e, categoryId, "close"),
    className: `ter-mobile-mega-menu-category__name ${parentOpen ? "" : "ter-mobile-mega-menu-category__name--hidden"} ${mouse ? "" : "tabFocus"}`,
    "data-depth": 2,
    "aria-haspopup": "menu",
    "aria-expanded": !(isOpen && !openSubCategory),
    ref: collapsedMenu
  }, name, /*#__PURE__*/_react.default.createElement("img", {
    className: `ter-mobile-mega-menu-category__caret`,
    src: _downCaretDarkBlue.default,
    alt: "caret icon"
  }))));
};
var _default = MobileMegaMenuCategory;
exports.default = _default;